/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalMCPTaskRecord } from './InternalMCPTaskRecord';
import {
    InternalMCPTaskRecordFromJSON,
    InternalMCPTaskRecordFromJSONTyped,
    InternalMCPTaskRecordToJSON,
    InternalMCPTaskRecordToJSONTyped,
} from './InternalMCPTaskRecord';

/**
 * 
 * @export
 * @interface InternalMCPTaskCreateResponse
 */
export interface InternalMCPTaskCreateResponse {
    /**
     * 
     * @type {InternalMCPTaskRecord}
     * @memberof InternalMCPTaskCreateResponse
     */
    task: InternalMCPTaskRecord;
    /**
     * 
     * @type {boolean}
     * @memberof InternalMCPTaskCreateResponse
     */
    created: boolean;
}

/**
 * Check if a given object implements the InternalMCPTaskCreateResponse interface.
 */
export function instanceOfInternalMCPTaskCreateResponse(value: object): value is InternalMCPTaskCreateResponse {
    if (!('task' in value) || value['task'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function InternalMCPTaskCreateResponseFromJSON(json: any): InternalMCPTaskCreateResponse {
    return InternalMCPTaskCreateResponseFromJSONTyped(json, false);
}

export function InternalMCPTaskCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'task': InternalMCPTaskRecordFromJSON(json['task']),
        'created': json['created'],
    };
}

export function InternalMCPTaskCreateResponseToJSON(json: any): InternalMCPTaskCreateResponse {
    return InternalMCPTaskCreateResponseToJSONTyped(json, false);
}

export function InternalMCPTaskCreateResponseToJSONTyped(value?: InternalMCPTaskCreateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task': InternalMCPTaskRecordToJSON(value['task']),
        'created': value['created'],
    };
}

